<template>
  <div>
    <Header></Header>
    <v-container fluid grid-list-xl class="margin-top-50px">
      <v-layout row>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-4">
          <div class="title text-xs-center form-divider ">ثبت کلاس جدید</div>
        </v-flex>
      </v-layout>
      <v-form ref="NewSystemUserForm" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-text-field
              :rules="nameRule"
              v-model="name"
              solo
              placeholder="کلاس جدید را وارد کنید"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-btn block color="indigo" dark @click="done(name)">
              <v-icon>done</v-icon>ثبت
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout row wrap>
        <v-flex xs12 lg12 md12 xl12 sm12>
          <div class="title text-xs-center form-divider padding-top-30px">آرشیو کلاس بندی ها</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 lg12 sm12 xl12 md12>
          <v-tabs dark color="cyan" show-arrows>
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="i in tabItems" :href="'#' + i.path" :key="i.path">
              <v-icon>{{i.icon}}</v-icon>
              {{i.title}}
            </v-tab>
            <v-tabs-items>
              <v-tab-item id="Users">
                <v-card class="full-width">
                  <v-data-table
                    :loading="userDataTableLoading"
                    no-data-text="داده ای یافت نشد"
                    next-icon="$vuetify.icons.prev"
                    prev-icon="$vuetify.icons.next"
                    rows-per-page-text="تعداد سطر در هر صفحه :"
                    rows-per-page-items="[ 5, 10, 25, { 'text':'همه',' 'value': -1 } ]"
                    :headers="classTableHeader"
                    :items="classTableItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.counter}}</td>
                      <td class="text-xs-right">{{props.item.Uname}}</td>

                      <td class="text-xs-right">
                        <v-icon small color="primary" @click="editUser(props.item)">create</v-icon>
                        <v-icon small color="error" @click="deleteUser(props.item)">delete</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item id="BlockedUsers">
                <v-card class="full-width">
                  <v-data-table
                    :loading="userDeletedDataTableLoading"
                    no-data-text="داده ای یافت نشد"
                    next-icon="$vuetify.icons.prev"
                    prev-icon="$vuetify.icons.next"
                    rows-per-page-text="تعداد سطر در هر صفحه :"
                    rows-per-page-items="[ 5, 10, 25, { 'text': 'همه', 'value': -1 } ]"
                    :headers="classTableHeader"
                    :items="UserTableDeletedItem"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.counter}}</td>
                      <td class="text-xs-right">{{props.item.Uname}}</td>

                      <td class="text-xs-right">
                        <v-btn color="orange" small dark @click="RecoverUser(props.item)">
                          <v-icon small color="white">redo</v-icon>بازگرداندن
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="confirmRecovery" width="500px">
            <v-card>
              <v-card-title>
                <v-icon color="info">redo</v-icon>بازگردانی کاربر
              </v-card-title>
              <v-card-text>کاربر مورد نظر مجددا فعال خواهد شد.ادامه میدهید؟</v-card-text>
              <!-- <v-card-action>
                            <v-btn flat color="success">بله</v-btn>
                            <v-btn flat color="error" >خیر</v-btn>
              </v-card-action>-->
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="ConfirmUser" width="500px">
            <v-card>
              <v-card-title>
                <v-icon color="error">delete</v-icon>حذف کاربر
              </v-card-title>
              <v-card-text>کاربر مورد نظر حذف خواهد شد.ادامه میدهید؟</v-card-text>
              <!-- <v-card-action >
                            <v-btn flat color="error" >بله</v-btn>
                            <v-btn flat color="info"  >خیر</v-btn>
              </v-card-action>-->
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import Header from "@/components/dashboard/Header";
import Api from "@/services/Api";

export default {
  data() {
    return {
      name: "",
      nameRule: [v => !!v || "این فیلد اجباری است"],
      msg: "",
      userDataTableLoading: true,
      tabItems: [
        { title: "کلاس فعال", path: "Users", icon: "account_circle" },
        {
          title: "کلاس حذف شده",
          path: "BlockedUsers",
          icon: "delete",
          method: "getDeletedUsers"
        }
      ],
      classTableHeader: [
        { text: "#", sortable: false, value: "counter", align: "right" },
        { text: "نام کلاس ", sortable: false, value: "User", align: "right" }
      ]
    };
  },
  components: {
    Header
  },
  methods: {
    async done(name) {
      try {
        let response;
        response = await Api().post("classification/insert", name);
        if (response == 1) {
          this.msg = "موفقیت آمیز";
        } else if (response == 0) {
          this.msg = "ناموفق";
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.margin-top-50px {
  margin-top: 50px;
}
</style>
